import { render, staticRenderFns } from "./ViewEmployees.vue?vue&type=template&id=6fc34f50&"
import script from "./ViewEmployees.vue?vue&type=script&lang=js&"
export * from "./ViewEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports